import { Institution } from "../../models/Institution";

export const DEFAULT_INSTITUTION_DETAILS: Institution = {
  id: 0,
  //Naziv ustanove
  name: "",
  //Šifra ustanove
  code: "",
  //Podšifra istanove
  subCode: "",
  oib: "",
  status: "",
  isSatellite: false,
  isByEnrollmentArea: false,
  isHandicapped: false,
  isPrivateInstitution: false,
  address: {
    houseNumber: "",
    street: "",
    town: "",
    municipality: "",
    county: "",
  },
  programs: [],
  //Izborni predmeti
  electiveSubjects: [],
  //Obvezni strani jezik
  mandatoryForeignLanguages: [],
  //Nastava na stranom jeziku
  foreignLanguages: [],
  //Produženi boravak
  //extendedStayClass: false,
  //Cjelodnevna nastava
  //allDayClass: false,
  //Organizacija rada u smjenama
  //shift: "",
  //Jezik nacionalne manjine
  //nationalMinorityLanguages: [],
  //Model
  languageSchoolingModels: [],
  cds: null,
  tur: null,
  institutionSchoolYearOtherArray: [],
  isReligious: false,
  isMinority: false,
};
